import { changeIdType, validateIdField } from '~/utilities/form-builder.reg';
import type { IFormBuilderReference } from '~/interfaces/form/formBuilder';

const useRegListeners = (form: Ref<IFormBuilderReference>) => {
  watch(
    () => form.value?.model?.['idNumber'],
    () => {
      validateIdField(form);
    },
  );
  watch(
    () => form.value?.model?.['idNumberType'],
    () => {
      changeIdType(form);
    },
  );
};

export default useRegListeners;
